// extracted by mini-css-extract-plugin
export default {"Form":"WBJ747Jmst07HSwH_E7j","Description":"hTiZpem_BY_M1nOVQl1x","ErrorMessage":"x7f85urTbaKU9XQA6Ht6"};